// extracted by mini-css-extract-plugin
module.exports = {"subscriptionVoucherWarnModal":"fl","header":"fm","body":"fn","buttonRow":"fo","buttonWrapper":"fp","button":"fq","error":"fr"};